import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import "./Mgrdetail.css";
import CustomVideoPlayer from "./CustomVideoPlayer";


export default function ApramattDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          Apramatt
        </h1>

        <p className="project-description">
          We partnered with Apramatt to build a premium digital presence, delivering a modern responsive website, engaging video editing for reels, and professional social media poster designs. Our creative focus was to showcase their photography and videography accessories through dynamic media formats and visually striking layouts that build a cohesive and impactful online brand.
        </p>

        <div className="project-tags">
          <span className="info-tag">Website Design</span>
          <span className="info-tag">Video Editing</span>
          <span className="info-tag">Social Media Design</span>
        </div>
      </section>

      {/* Full landscape image */}
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Apramatt/Full1.webp" alt="Apramatt Branding Showcase" />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We built a responsive, modern website for Apramatt, focusing on clean user experiences, seamless navigation, and high-quality product photography to showcase their range of camera accessories."
        </div>
      </section>

      {/* Three portrait videos in a row */}
      <section className="project-three-videos-section">
        <CustomVideoPlayer
          src="https://ascentbw.com/Images/Apramatt/Vid1.webm"
          autoPlay
          loop
          muted
          playsInline
        />
        <CustomVideoPlayer
          src="https://ascentbw.com/Images/Apramatt/Vid2.webm"
          autoPlay
          loop
          muted
          playsInline
        />
        <CustomVideoPlayer
          src="https://ascentbw.com/Images/Apramatt/Vid3.webm"
          autoPlay
          loop
          muted
          playsInline
        />
      </section>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We produced and edited high-impact video content and reels for Apramatt, showcasing their camera accessories in action with dynamic pacing, professional transitions, and engaging storytelling designed for social media feeds."
        </div>
      </section>

           
      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Apramatt/Full2.webp" alt="Apramatt Branding Showcase" />
      </div>


      <div className="project-full-image-section">
        <img src="https://ascentbw.com/Images/Apramatt/Full3.webp" alt="Apramatt Branding Showcase" />
      </div>

    

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We designed a series of premium social media posters and digital templates for Apramatt, combining striking product imagery with bold layouts to elevate their social media presence and visual storytelling."
        </div>
      </section>

   

      <RelatedWorks excludePath="/works/apramatt" />
      <Footer />
    </div>
  );
}
